// routes/_app.membership.tsx
import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.membership'

const getClientModule = () => import('src/clientRoutes/_app.membership')

export const handle = {
  name: 'membership',
  hideMembershipBanner: true,
  showCreditPill: true,
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('common:meta.title.membership'),
    description: t('common:meta.description.membership'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
